import { SchoolYearSchema } from '@/core/infrastructure/schemas/school/year/SchoolYearSchema'
import { SchoolUserSchema } from '@/core/infrastructure/schemas/school/user/SchoolUserSchema'
import { z } from 'zod'
import { SchoolPeriodUserSchema } from '@/core/infrastructure/schemas/school/user/SchoolPeriodUserSchema.ts'
import { SchoolClassroomsListItemSchema } from '@/core/infrastructure/schemas/school/classroom/SchoolClassroomSchema.ts'

export const SchoolPeriodSchema = z.object({
  schoolPeriodId: z.number(),
  schoolYear: SchoolYearSchema,
  schoolId: z.number(),
  countStudents: z.number(),
  countTeachers: z.number(),
  countClassrooms: z.number()
})

export const SchoolPeriodFetchAndCreateResponseSchema = z.object({
  schoolPeriodId: z.number(),
  schoolYear: SchoolYearSchema,
  schoolId: z.number(),
  users: z.array(SchoolPeriodUserSchema),
  classrooms: z.array(SchoolClassroomsListItemSchema)
})
export type SchoolPeriodFetchAndCreateResponseEntity = z.infer<typeof SchoolPeriodFetchAndCreateResponseSchema>


export const SchoolCreatePeriodResponseSchema = z.object({
  schoolPeriodId: z.number(),
  schoolYear: SchoolYearSchema,
  schoolId: z.number(),
  users: z.array(SchoolUserSchema)
})

export const SchoolPeriodsListSchema = z.array(SchoolPeriodSchema)

export type SchoolPeriodEntity = z.infer<typeof SchoolPeriodSchema>
export type SchoolPeriodsListEntity = z.infer<typeof SchoolPeriodsListSchema>
